import React from 'react';

import {
  OverallOrderStatusName,
  useSummaryInformationWidgetQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';



export interface IOrder {
  orderNumber: string;
  orderDate: DateTime;
  orderStatusName: OverallOrderStatusName;
  orderStatusDisplayName: string;
}

export interface IData {

  order: IOrder | null;
}

export function useQuery(orderId: string) {
  const tuple = useSummaryInformationWidgetQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {

        order: tuple.data?.orderLite ? {
          orderDate: DateTime.fromISO(tuple.data.orderLite.orderDate),
          orderNumber: tuple.data.orderLite.orderNumber,
          orderStatusName: tuple.data?.orderLite?.overallOrderStatus.name ?? 'open',
          orderStatusDisplayName: tuple.data?.orderLite?.overallOrderStatus.displayName ?? 'Open'
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
